import { Pencil, Trash2,  Plus } from "lucide-react";

export default function ChatSidebar({
  chats,
  onNewChat,
  onSelectChat,
  onDeleteChat,
  onEditTitle,
  activeChatIndex,
  editingIndex,
  setEditingIndex,
}) {

  return (
    <aside className="w-64 bg-slate-900 text-white h-screen p-4 flex flex-col border-r border-slate-800">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-sm font-bold uppercase tracking-widest text-slate-400">
          History
        </h2>
        <button
          onClick={onNewChat}
          className="flex items-center gap-1 text-xs bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded-lg transition-colors font-semibold"
        >
          <Plus className="w-3 h-3" /> New
        </button>
      </div>

      {/* Chat List */}
      <div className="flex-1 overflow-y-auto space-y-1 pr-2 custom-scrollbar">
        {chats.length === 0 && (
          <p className="text-slate-500 text-sm italic px-3">No recent chats</p>
        )}
        
        {chats.map((chat, idx) => (
          <div
            key={idx}
            className={`group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm transition-all cursor-pointer ${
              idx === activeChatIndex
                ? "bg-slate-800 text-purple-400 border border-slate-700"
                : "text-slate-400 hover:bg-slate-800/50 hover:text-slate-200"
            }`}
          >
            {editingIndex === idx ? (
              <input
                autoFocus
                defaultValue={chat.title}
                onBlur={(e) =>
                  onEditTitle(chat.conversationId, e.target.value, idx)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.target.blur();
                }}
                className="w-full bg-transparent border-b border-purple-500 focus:outline-none text-white"
              />
            ) : (
              <button
                onClick={() => onSelectChat(idx)}
                className="text-left truncate w-full font-medium"
              >
                {chat.title || `Chat ${idx + 1}`}
              </button>
            )}

            <div className="flex items-center opacity-0 group-hover:opacity-100 transition-opacity ml-2">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingIndex(idx);
                }}
                className="p-1 text-slate-500 hover:text-blue-400"
              >
                <Pencil className="w-3.5 h-3.5" />
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteChat(chat.conversationId, idx);
                }}
                className="p-1 text-slate-500 hover:text-red-400"
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Talk to AI Bot Section */}
      {/* {user?.role !== "admin" && (
        <div className="mt-auto pt-6 border-t border-slate-800 flex flex-col items-center">
          <motion.button
            onClick={() => navigate("/dashboard/crm-ai/odoo/chatbot")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="relative flex items-center justify-center p-4 rounded-2xl shadow-lg text-white bg-gradient-to-br from-purple-600 to-indigo-700 hover:shadow-purple-500/20"
          >
            <User className="w-6 h-6 z-10" />
            {[...Array(2)].map((_, i) => (
              <motion.span
                key={i}
                className="absolute rounded-2xl border border-purple-400/30"
                style={{ width: "100%", height: "100%" }}
                animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.1, 0.3] }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 1,
                }}
              />
            ))}
          </motion.button>

          <span className="mt-3 text-xs font-bold text-slate-400 uppercase tracking-widest">
            Odoo AI Assistant
          </span>
        </div>
      )} */}
    </aside>
  );
}